
export default {
  simplePlaceSearch: {
    noPlaceFound: 'No place found with the imputed content',
    openSidebarToSeeRouteDetails: 'Open the sidebar to see route details',
    unknownSearchPlaceError: 'Unknown search place error'
  }
}
